import {UserPhoneVerification as UserPhoneVerificationBase} from "@pg-mono/user";

import {UserPhoneVerificationProvider} from "../../providers/UserPhoneVerificationProvider";
import {trackAmplitudePhoneVerified} from "../../tracking/track_amplitude_phone_verified";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    onChangeNumber: () => void;
}

export const HomeMatchBasicPreferencesFlowPhoneVerificationModal = (props: IProps) => {
    const {isOpen, onClose, onSuccess, onChangeNumber} = props;

    const handleClose = () => {
        trackAmplitudePhoneVerified(false);
        onClose();
    };

    return (
        <UserPhoneVerificationProvider>
            <UserPhoneVerificationBase isOpen={isOpen} onClose={handleClose} onSuccess={onSuccess} onChangeNumber={onChangeNumber} />
        </UserPhoneVerificationProvider>
    );
};
import {UserPhoneVerification as UserPhoneVerificationBase} from "@pg-mono/user";

import {UserPhoneVerificationProvider} from "../../providers/UserPhoneVerificationProvider";
import {trackAmplitudePhoneVerified} from "../../tracking/track_amplitude_phone_verified";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    onChangeNumber: () => void;
}

export const HomeMatchBasicPreferencesFlowPhoneVerificationModal = (props: IProps) => {
    const {isOpen, onClose, onSuccess, onChangeNumber} = props;

    const handleClose = () => {
        trackAmplitudePhoneVerified(false);
        onClose();
    };

    return (
        <UserPhoneVerificationProvider>
            <UserPhoneVerificationBase isOpen={isOpen} onClose={handleClose} onSuccess={onSuccess} onChangeNumber={onChangeNumber} />
        </UserPhoneVerificationProvider>
    );
};
